import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterOutlet } from '@angular/router';
import { BookingService } from '../../services/api/BookingService';
import { BookingModel } from '../../models/api/BookingModel';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-client-portal',
  standalone: true,
  imports: [RouterOutlet, MatButtonModule, MatMenuModule, MatIconModule],
  templateUrl: './client-portal.component.html',
  styleUrl: './client-portal.component.scss'
})
export class ClientPortalLayoutComponent implements OnInit {

  private authUser = localStorage.getItem('AuthUser');
  private bookingGuid = localStorage.getItem('bookingGuid');
  bookingDetail = new BookingModel();
  private userAgent: string = navigator.userAgent;
  public isAndroid: boolean = false;
  public isAppUser: boolean = false;

  constructor(private router: Router,
    private platform: Platform,
    private bookingService: BookingService,
    private location: LocationStrategy,
  ) {
  }
  ngOnInit(): void {

    //if (this.bookingGuid) {
    //  this.bookingService.getBooking(this.bookingGuid).subscribe(data => {
    //    this.bookingDetail = data;

    //    if (this.bookingDetail && (this.bookingDetail.bookingStatusID === 2 || this.bookingDetail.bookingStatusID === 3 || this.bookingDetail.bookingStatusID === 4 || this.bookingDetail.bookingStatusID === 5)) {
    //      this.router.navigate(['client-portal', 'queue', this.bookingGuid]);
    //    } else {
    //      localStorage.removeItem('bookingGuid');
    //    }
    //  })
    //}

    if (this.userAgent) {
      if (this.userAgent.includes("WHAppIOS") || this.userAgent.includes("WHAppAndroid")) {
        this.isAppUser = true;
      }
      if (this.platform.ANDROID) {
          this.isAndroid = true;
        }
    }

    ////check if is a logged in user and redirects if so!
    //if (this.authUser) {
      
    //  const parsedUser = JSON.parse(this.authUser);
    //  console.log("client-portal:has auth user", parsedUser);
    //  //is admin
    //  if (parsedUser.user.userTypeID === 1 || parsedUser.user.userTypeID === 2) {
    //    console.log("client-portal:nav to admin");
    //    this.router.navigate(['admin', 'events']);
    //  }
    //  //is therapist
    //  else if (parsedUser.user.userTypeID === 3) {
    //    console.log("client-portal:nav to therapist dashboard");
    //    this.router.navigate(['therapist-portal', 'dashboard']);
    //  }
    //}
  }

openOrInstallApp(event: Event): void {
    event.preventDefault();
    const appLink = 'intent://winninghands.app#Intent;scheme=https;package=app.winninghands;end';
    const playStoreLink = 'https://play.google.com/store/apps/details?id=app.winninghands';

    const start = Date.now();
    window.location.href = appLink;

    setTimeout(() => {
      if (Date.now() - start < 2000) {
        window.location.href = playStoreLink;
      }
    }, 1500);
  }

  goToLogin() {
    this.router.navigate(['login']);
  }
  goToBook() {
    this.router.navigate(['/']);
  }

  goBack() {
    this.location.back();
  }
}
